import en from './en'
import cn from './cn'
import ft from './ft'

export default {
  en, cn, ft
}
